// extracted by mini-css-extract-plugin
export default {"powerBy":"powerBy-RvY3N8","modal":"modal-mpgYCS"};